module.exports = __webpack_public_path__ + "js/0.f3a31b6f.worker.js"